<section class="container-capped d-flex flex-column gap-2 py-2 h-100 px-0 mr-md-0"
	[class.light-gray-bg]="Utility.mobile">
	<app-breadcrumb [breadcrumb-data]="breadcrumbData" [hide-last]="0" *ngIf="breadcrumbData">
	</app-breadcrumb>
	<app-search-box [(ngModel)]="searchParams" searchType="rtwad" queryPlaceholder="دنبال چه خدمات یا مهارتی هستید؟"
		locationPlaceholder="در چه شهری؟"></app-search-box>
	<h1 class="fs-normal mb-0 px-1 border-bottom border-3 border-dark-gray">{{title}}</h1>
	<div class="relative">
		<ngx-spinner name="rtwad-list" [fullScreen]="true" type="timer"></ngx-spinner>

		<div class="d-flex flex-column gap-1" *ngIf="searchResult?.Total>0; else noResultsFound">
			<ng-container *ngFor="let rtwad of searchResult.List;let i=index">
				<app-rtwad-summary [rtwad]="rtwad"></app-rtwad-summary>
				<div *ngIf="i==2 || (searchResult.Total<2 && i==searchResult.Total-1)" class="kp-questioner p-3"
					routerLink="/account/rtw/post">
					<h4>می‌خوای تو هم مهارت یا خدماتت رو تبلیغ کنی و مشتری جذب کنی؟</h4>
					<div class="py-1 d-flex align-items-center justify-content-center">
						<a class="btn btn-primary mx-3">آگهی آماده‌به‌کار ثبت کن</a>
					</div>
				</div>
			</ng-container>
			<div class="text-center" *ngIf="from<searchResult.Total-limit">
				<div class="relative text-center" style="height: 30px;">
					<ngx-spinner name="rtwad-list-more" [fullScreen]="false" bdColor="rgba(0,0,0,0)" color="gray"
						type="square-jelly-box" size="small"></ngx-spinner>
				</div>
				<div class="btn btn-secondary mb-2" (click)="loadMore()">
					<div class="flex-grow-1">مشاهده نتایج بیشتر</div>
					<i class="fa fa-angle-down mr-2"></i>
				</div>
			</div>
		</div>
		<ng-template #noResultsFound>
			<div *ngIf="dataLoadedFirstTime" class="kp-message kp-message-warning p-3 text-center fw-bold" #noResultsFound>
				نتیجه‌ای برای این جستجو پیدا نشد. </div>
		</ng-template>
	</div>
</section>